(function () {
  const wizard = document.querySelector('.wizard');
  if (!wizard) { return; }
  const wizardToggle = document.querySelector('.wizard-toggle');
  const backButton = document.querySelector('.wizard-btn-back');
  const nextButton = document.querySelector('.wizard-btn-next');
  const contents = document.querySelectorAll('.wizard-body-content');
  const wizardHeader = document.querySelector('.wizard-header');
  const wizardDeskVert = wizard.querySelector('.wizard-desktop-vertical');

  const LARGURA_TELA_MAX_HORIZONTAL = 576;
  const LARGURA_TELA_MAX_VERTICAL = 768;

  function aplicarStepVertical() {
    const step = wizard.querySelector('.step');

    if (wizardDeskVert) step.classList.add('step-vertical');
  }

  function ajustarLarguraTela() {
    const step = wizard.querySelector('.step');
    const LARGURA_TELA = document.documentElement.clientWidth;

    if (
      (LARGURA_TELA < LARGURA_TELA_MAX_VERTICAL && wizardDeskVert) ||
      LARGURA_TELA < LARGURA_TELA_MAX_HORIZONTAL
    ) {
      aplicarEstilosMobile(wizard, step);
    } else {
      aplicarEstilosDesktop(wizard, step);
    }

    aplicarStepVertical();
  }

  function aplicarEstilosMobile(wizard, step) {
    wizard.classList.add('wizard-vertical');
    wizardToggle.style.display = 'flex';
    wizardHeader.style.display = 'none';
    backButton.innerHTML = '<i class="fas fa-chevron-left"></i>';
    nextButton.innerHTML = '<i class="fas fa-chevron-right"></i>';
    atualizarBotaoEstilos('btn-secondary', 'btn-secondary-icon');
    atualizarBotaoEstilos('btn-primary', 'btn-primary-icon');
  }

  function aplicarEstilosDesktop(wizard, step) {
    wizard.classList.remove('wizard-vertical');
    wizardToggle.style.display = 'none';
    if (wizardToggle.classList.contains('wizard-toggle-expanded')) {
      resetarBotaoToggle();
    }
    wizardHeader.style.display = 'block';
    backButton.innerHTML = 'Voltar';
    nextButton.innerHTML = 'Avançar';
    atualizarBotaoEstilos('btn-secondary-icon', 'btn-secondary');
    atualizarBotaoEstilos('btn-primary-icon', 'btn-primary');
  }

  function atualizarBotaoEstilos(removedClass, addedClass) {
    backButton.classList.replace(removedClass, addedClass);
    nextButton.classList.replace(removedClass, addedClass);
  }

  function resetarBotaoToggle() {
    wizardToggle.classList.remove('wizard-toggle-expanded');
    wizardToggle.setAttribute('aria-expanded', 'false');
    wizardToggle
      .querySelector('i')
      .classList.replace('fa-chevron-up', 'fa-chevron-down');
    wizardHeader.style.display = 'none';
  }

  function atualizarWizardItemClasses() {
    const activeStep = document.querySelector('.step-progress-item.active');
    const wizardItem = document.querySelector('.wizard-status');
    if (activeStep && wizardItem) {
      resetarClasses(wizardItem);
      adicionarClassesBaseadasNoStatus(activeStep, wizardItem);
    }
  }

  function resetarClasses(element) {
    element.className = 'wizard-status';
  }

  function adicionarClassesBaseadasNoStatus(activeStep, wizardItem) {
    const stepIcon = activeStep.querySelector('.step-icon');
    if (stepIcon) {
      stepIcon.classList.forEach((cls) => {
        wizardItem.classList.add(cls);
        wizardItem.classList.remove('step-icon');
      });
    } else {
      wizardItem.classList.add('wizard-bullet');
    }

    if (activeStep.classList.contains('step-success')) {
      wizardItem.classList.add('wizard-success');
    } else if (activeStep.classList.contains('step-warning')) {
      wizardItem.classList.add('wizard-warning');
    } else if (activeStep.classList.contains('step-danger')) {
      wizardItem.classList.add('wizard-danger');
    }

    if (
      wizardItem.classList.contains('wizard-success') ||
      wizardItem.classList.contains('wizard-warning') ||
      wizardItem.classList.contains('wizard-danger') ||
      wizardItem.classList.contains('wizard-bullet')
    ) {
      wizardItem.classList.add('wizard-item');
    }
  }

  function atualizarWizardTexto() {
    const activeStep = document.querySelector(
      '.step-progress-item.active .step-label'
    );
    const wizardText = document.querySelector('.wizard-text');
    if (activeStep && wizardText) {
      wizardText.textContent = activeStep.textContent;
    }
  }

  function configurarObservadorDeMutacoes() {
    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          const activeContentIndex = Array.from(contents).findIndex((content) =>
            content.classList.contains('active')
          );
          if (activeContentIndex !== -1) {
            atualizarWizardTexto();
            atualizarWizardItemClasses();
          }
        }
      }
    });

    contents.forEach((content) => {
      observer.observe(content, { attributes: true });
    });
  }

  function configurarEventoToggle() {
    if (!wizardToggle) return;
    wizardToggle.addEventListener('click', (event) => {
      event.stopPropagation();
      const isExpanded = wizardToggle.classList.toggle(
        'wizard-toggle-expanded'
      );
      wizardToggle.setAttribute('aria-expanded', isExpanded);
      wizardHeader.style.display = isExpanded ? 'block' : 'none';
      atualizarIconeToggle(isExpanded);
    });

    document.addEventListener('click', () => {
      if (wizardToggle.classList.contains('wizard-toggle-expanded')) {
        resetarBotaoToggle();
      }
    });
  }

  function atualizarIconeToggle(isExpanded) {
    if (isExpanded) {
      wizardToggle
        .querySelector('i')
        .classList.replace('fa-chevron-down', 'fa-chevron-up');
    } else {
      wizardToggle
        .querySelector('i')
        .classList.replace('fa-chevron-up', 'fa-chevron-down');
    }
  }
  ajustarLarguraTela();
  atualizarWizardItemClasses();
  atualizarWizardTexto();
  configurarObservadorDeMutacoes();
  configurarEventoToggle();

  window.addEventListener('resize', ajustarLarguraTela);
})();
